import * as z from 'zod';

import { contactQueryLinkerSchema } from '@/_pages/contacts/shared';
import { recruitingHiringCriteriaCategoryQueryLinkerSchema } from '@/_pages/settings/recruiting-hiring-criteria-categories/shared';
import { recruitingJobCategoryQueryLinkerSchema } from '@/_pages/settings/recruiting-job-categories/shared';
import { recruitingStatusQueryLinkerSchema } from '@/_pages/settings/recruiting-statuses/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { paginatedResponseSchema, urlSchema } from '@/_schemas/generic';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';
import { teamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';

import { recruitingQueryLinkerSchema } from './recruiting-query-linker-schema';

const referralSchema = z.union([teamMemberQueryLinkerSchema, contactQueryLinkerSchema]);
export const referralTypeSchema = z.union([z.literal('team-member'), z.literal('contact')]);
export type ReferralTypeSchema = z.infer<typeof referralTypeSchema>;

export const recruitingQuerySchema = z.object({
  ...recruitingQueryLinkerSchema.shape,

  profile_image: z.array(fileQuerySchema).nullish(),
  linked_in: urlSchema(true),
  email: z.string().nullish(),
  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
  recruiting_tags: z.string().nullish(),
  recruiting_status_id: z.number().nullish(),
  recruiting_status: recruitingStatusQueryLinkerSchema.nullish(),
  notes: z.string().nullish(),
  recruiting_job_categories: z.array(recruitingJobCategoryQueryLinkerSchema).nullish(),
  hiring_criteria_categories: z.array(recruitingHiringCriteriaCategoryQueryLinkerSchema).nullish(),
  referral_id: z.number().nullish(),
  referral_type: referralTypeSchema.nullish(),
  referral: referralSchema.nullish(),
  resume: z.array(fileQuerySchema).nullish(),
  additional_documents: z.array(fileQuerySchema).nullish(),
});

export type RecruitingQuerySchema = z.infer<typeof recruitingQuerySchema>;

export const recruitingQueryAllSchema = paginatedResponseSchema(recruitingQuerySchema);

export type RecruitingQueryAllSchema = z.infer<typeof recruitingQueryAllSchema>;
